import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV, SERVICES } from "../mock";

export default function Footer() {
  return (
    <footer className="brand-texture bg-[#15264a] text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <img
              src={BRAND.logoLight}
              alt={BRAND.name}
              className="mb-5 h-36 w-auto"
            />
            <p className="max-w-xs text-sm leading-relaxed text-white/70">
              A family-run property company making home ownership a reality and
              building communities that last.
            </p>
          </div>

          <div>
            <h4 className="mb-5 text-sm font-semibold uppercase tracking-widest text-[#C9A876]">
              Explore
            </h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="text-sm text-white/75 transition-colors hover:text-[#C9A876]"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-5 text-sm font-semibold uppercase tracking-widest text-[#C9A876]">
              Our Services
            </h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services#${s.id}`}
                    className="text-sm text-white/75 transition-colors hover:text-[#C9A876]"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-5 text-sm font-semibold uppercase tracking-widest text-[#C9A876]">
              Get In Touch
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A876]" />
                <a href={BRAND.phoneHref} className="text-sm text-white/75 hover:text-white">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A876]" />
                <a href={`mailto:${BRAND.email}`} className="text-sm text-white/75 hover:text-white">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#C9A876]" />
                <span className="text-sm text-white/75">{BRAND.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            Building Homes · Shaping Communities · Creating Legacies
          </p>
        </div>
      </div>
    </footer>
  );
}
